<template>
    <div id="app">
        <router-view name='head' class="wow animate__fadeInDownBig" />
        <transition name="slide-fade">
            <router-view name='main' :key="key" />
        </transition>
        <router-view name='foot' class="wow animate__fadeIn" />
    </div>
</template>
<script>
import { WOW } from "wowjs";
export default {
    computed: {
        key() {
            return this.$route.name !== undefined
                ? this.$route.name + +new Date()
                : this.$route + +new Date();
        },
    },
    mounted() {
        this.$nextTick(() => {
            const wow = new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                offset: 0,
                mobile: true,
                live: false,
            });
            wow.init();
        });
    },
};
</script>>
<style>
.el-cascader-panel {
    font-size: 0.13rem !important;
}
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
    color: #15c3cc !important;
}
.el-cascader-node {
    height: 0.3rem !important;
}
.el-cascader {
    line-height: 1 !important;
}
.el-select-dropdown__item.selected {
    color: #15c3cc !important;
}
.el-select-dropdown__item {
    font-size: 0.13rem !important;
    height: 0.3rem !important;
    display: flex;
    align-items: center;
}
.el-cascader-menu__wrap {
    height: 3rem !important;
}
.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-enter {
    transform: translateX(-100%);
    opacity: 0;
}
.slide-fade-leave-to {
    opacity: 0;
}
</style>
